webpackJsonp([11],{

/***/ 134:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 135:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(213)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(164),
  /* template */
  __webpack_require__(337),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 138:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceFactory; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__userService__ = __webpack_require__(179);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__adminService__ = __webpack_require__(171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__orderService__ = __webpack_require__(177);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__productService__ = __webpack_require__(178);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__clientService__ = __webpack_require__(173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__addressService__ = __webpack_require__(170);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__cancelReasonService__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__couriersReportsService__ = __webpack_require__(174);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__dashboardService__ = __webpack_require__(175);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__mapService__ = __webpack_require__(176);












var services = {
  user: __WEBPACK_IMPORTED_MODULE_0__userService__["a" /* default */],
  admin: __WEBPACK_IMPORTED_MODULE_1__adminService__["a" /* default */],
  order: __WEBPACK_IMPORTED_MODULE_2__orderService__["a" /* default */],
  product: __WEBPACK_IMPORTED_MODULE_3__productService__["a" /* default */],
  client: __WEBPACK_IMPORTED_MODULE_4__clientService__["a" /* default */],
  address: __WEBPACK_IMPORTED_MODULE_5__addressService__["a" /* default */],
  cancelReason: __WEBPACK_IMPORTED_MODULE_6__cancelReasonService__["a" /* default */],
  couriersReports: __WEBPACK_IMPORTED_MODULE_7__couriersReportsService__["a" /* default */],
  dashboard: __WEBPACK_IMPORTED_MODULE_8__dashboardService__["a" /* default */],
  map: __WEBPACK_IMPORTED_MODULE_9__mapService__["a" /* default */]
};

var serviceFactory = {
  get: function get(name) {
    return services[name];
  }
};

/***/ }),

/***/ 164:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__apiServices_serviceFactory__ = __webpack_require__(138);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__apiServices_menu__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(44);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var userService = __WEBPACK_IMPORTED_MODULE_0__apiServices_serviceFactory__["a" /* serviceFactory */].get("user");


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      drawer: true,
      mini: false,
      right: null,
      balance: '-',
      userPayload: userService.getUserPayload()
    };
  },
  mounted: function mounted() {
    if (!this.isAuthenticated) {
      this.drawer = false;
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
    }
    this.refresh();
  },

  watch: {
    userPayload: {
      deep: true,
      handler: function handler() {
        var _this = this;

        this.menu = __WEBPACK_IMPORTED_MODULE_1__apiServices_menu__["a" /* menu */].filter(function (x) {
          if (x.Access.indexOf(_this.userPayload.role.toUpperCase()) > -1) {
            x.Pages = x.Pages.filter(function (z) {
              return z.Access.indexOf(_this.userPayload.role.toUpperCase()) > -1;
            });
            return x;
          }
        });
      }
    }
  },
  computed: {
    isAuthenticated: function isAuthenticated() {
      if (this.userPayload == undefined || this.userPayload.exp == undefined) return false;
      var isExpired = this.userPayload.exp < Math.round(new Date().getTime() / 1000);
      return !isExpired;
    },
    screenWidth: function screenWidth() {
      return document.documentElement.clientWidth;
    },
    userMenu: function userMenu() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1__apiServices_menu__["a" /* menu */].filter(function (x) {
        if (x.Access.indexOf(_this2.userPayload.role.toUpperCase()) > -1) {
          x.Pages = x.Pages.filter(function (z) {
            return z.Access.indexOf(_this2.userPayload.role.toUpperCase()) > -1;
          });
          return x;
        }
      });
    }
  },
  methods: {
    refresh: function refresh() {
      this.drawer = true;
      this.userPayload = userService.getUserPayload();
    },
    logout: function logout() {
      this.drawer = false;
      this.balance = '-';
      localStorage.clear();
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push('/login');
    },
    navigate: function navigate(url) {
      if (url != '' && url != undefined) {
        __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push(url);
      }
    }
  }

});

/***/ }),

/***/ 170:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("address/" + query);
  },
  getByBuildingId: function getByBuildingId(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("address/by-building-id" + query);
  }
});

/***/ }),

/***/ 171:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__client__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  getRoles: function getRoles(params) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* default */].get("Role", { params: params });
  },
  getSchedules: function getSchedules(params) {
    return __WEBPACK_IMPORTED_MODULE_0__client__["a" /* default */].get("Schedule", { params: params });
  }
});

/***/ }),

/***/ 172:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("cancelReason/" + query);
  }
});

/***/ }),

/***/ 173:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("client/" + query);
  },
  create: function create(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("client/", body);
  },
  edit: function edit(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("client/", body);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].delete("client/" + id);
  }
});

/***/ }),

/***/ 174:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("CourierDailyReports/couriers", body);
  },
  getCouriers: function getCouriers(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("courier/" + query);
  },
  accept: function accept(id, status) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("CourierDailyReports/" + id + "?status=" + status, null);
  }
});

/***/ }),

/***/ 175:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getClientsStatistic: function getClientsStatistic(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("DeliveryManager/ClientsStatistic" + query);
  }
});

/***/ }),

/***/ 176:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  search: function search(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("address/" + query);
  }
});

/***/ }),

/***/ 177:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  getOperatorOrders: function getOperatorOrders(params) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("order/table", params);
  },
  create: function create(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("order/", body);
  },
  edit: function edit(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("order/", body);
  },
  cancel: function cancel(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("order/cancel", body);
  },
  getById: function getById(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("order/" + id);
  },
  getClientOrders: function getClientOrders(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("order/by-client" + query);
  },
  getProductOrders: function getProductOrders(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("order/by-product" + query);
  }
});

/***/ }),

/***/ 178:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);



/* harmony default export */ __webpack_exports__["a"] = ({
  get: function get(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("product/" + query);
  },
  create: function create(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("product/", body);
  },
  edit: function edit(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("product/", body);
  },
  uploadPhoto: function uploadPhoto(photo) {
    var formData = new FormData();
    formData.append("photo", photo);
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("files/photo", formData);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].delete("product/" + id);
  }
});

/***/ }),

/***/ 179:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__client__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__menu__ = __webpack_require__(90);




/* harmony default export */ __webpack_exports__["a"] = ({
  login: function login(body) {
    var _this = this;

    var request = __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("User/Login", body);
    request.then(function (response) {
      var data = response.data;

      localStorage.setItem("token", data.token);
      localStorage.setItem("userData", _this.parseJwt(data.token));
    });
    return request;
  },
  parseJwt: function parseJwt(token) {
    var base64Url = token.split(".")[1];
    var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
    var jsonPayload = decodeURIComponent(atob(base64).split("").map(function (c) {
      return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
    }).join(""));
    return jsonPayload;
  },
  getUserPayload: function getUserPayload() {
    return JSON.parse(localStorage.getItem("userData"));
  },
  get: function get(params) {
    var query = "?";
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(params).forEach(function (k) {
      query += k + "=" + params[k] + "&";
    });
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].get("user/" + query);
  },
  create: function create(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].post("user/", body);
  },
  edit: function edit(body) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].put("user/", body);
  },
  delete: function _delete(id) {
    return __WEBPACK_IMPORTED_MODULE_1__client__["a" /* default */].delete("user/" + id);
  }
});

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App__ = __webpack_require__(135);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify__ = __webpack_require__(137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__ = __webpack_require__(136);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue2_google_maps___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__ = __webpack_require__(134);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vuetify_dist_vuetify_min_css__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









var toastrConfigs = {
  position: 'top right',
  showDuration: 1000,
  timeOut: 5000,
  progressBar: true,
  showMethod: 'fadeInUp',
  hideMethod: 'fadeOutDown'
};

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_cxlt_vue2_toastr___default.a, toastrConfigs);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vuetify___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue2_google_maps__, {
  load: {
    key: 'AIzaSyA92fLXWQSL1z3lVh3iz76KRPP6E7TAyBk',
    libraries: 'places' // This is required if you use the Autocomplete plugin 
    // OR: libraries: 'places,drawing' 
    // OR: libraries: 'places,drawing,visualization' 
    // (as you require) 
  }
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__components_App___default.a }
});

Number.prototype.toCurrency = function () {
  var withSymbol = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

  var formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: 0
  });
  return formatter.format(this) + (withSymbol ? " ₽ " : "");
};

/***/ }),

/***/ 211:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 212:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 213:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 327:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(165),
  /* template */
  __webpack_require__(333),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 328:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(166),
  /* template */
  __webpack_require__(332),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 329:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(212)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(167),
  /* template */
  __webpack_require__(335),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 330:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(168),
  /* template */
  __webpack_require__(336),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 331:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(211)
}
var Component = __webpack_require__(17)(
  /* script */
  __webpack_require__(169),
  /* template */
  __webpack_require__(334),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 332:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    ref: "flyaway"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}

/***/ }),

/***/ 333:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('input', {
    ref: "input",
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.value
    }
  })
},staticRenderFns: []}

/***/ }),

/***/ 334:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-street-view-pano-container"
  }, [_c('div', {
    ref: "vue-street-view-pano",
    staticClass: "vue-street-view-pano"
  }), _vm._v(" "), _vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 335:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vue-map-container"
  }, [_c('div', {
    ref: "vue-map",
    staticClass: "vue-map"
  }), _vm._v(" "), _c('div', {
    staticClass: "vue-map-hidden"
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._t("visible")], 2)
},staticRenderFns: []}

/***/ }),

/***/ 336:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_c('span', {
    domProps: {
      "textContent": _vm._s(_vm.label)
    }
  }), _vm._v(" "), _c('input', {
    ref: "input",
    class: _vm.className,
    attrs: {
      "type": "text",
      "placeholder": _vm.placeholder
    }
  })])
},staticRenderFns: []}

/***/ }),

/***/ 337:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "inspire",
      "standalone": ""
    }
  }, [(_vm.isAuthenticated) ? _c('v-navigation-drawer', {
    attrs: {
      "app": "",
      "persistent": "",
      "dark": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-toolbar', {
    staticClass: "teal",
    attrs: {
      "flat": ""
    }
  }, [_c('v-list-tile-action', {
    staticStyle: {
      "margin-right": "15px"
    }
  }, [_c('v-icon', {
    attrs: {
      "x-large": ""
    }
  }, [_vm._v("account_circle")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.userPayload.role))]), _vm._v(" "), _c('v-list-tile-sub-title', {
    staticClass: "white--text"
  }, [_vm._v(_vm._s(_vm.userPayload.FullName))])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, _vm._l((_vm.userMenu), function(section) {
    return _c('v-list-group', {
      key: section.Title,
      attrs: {
        "group": section.Title,
        "prepend-icon": section.Icon,
        "no-action": "no-action"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "activator",
        "ripple": "ripple"
      },
      on: {
        "click": function($event) {
          return _vm.navigate(section.Path)
        }
      },
      slot: "activator"
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(section.Title))])], 1)], 1), _vm._v(" "), _vm._l((section.Pages), function(subItem) {
      return _c('v-list-tile', {
        key: subItem.Title,
        staticStyle: {
          "margin-left": "-25px"
        },
        on: {
          "click": function($event) {
            return _vm.navigate(subItem.Path)
          }
        }
      }, [(subItem.Icon) ? _c('v-list-tile-avatar', [_c('v-icon', [_vm._v(_vm._s(subItem.Icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(subItem.Title))])], 1)], 1)
    })], 2)
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('v-toolbar', {
    staticClass: "indigo darken-4",
    attrs: {
      "fixed": "",
      "app": "",
      "dark": ""
    }
  }, [(_vm.isAuthenticated) ? _c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        _vm.drawer = !_vm.drawer
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Маркет АП")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.screenWidth > 500) ? [(_vm.isAuthenticated) ? _c('v-btn', {
    attrs: {
      "flat": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("Выйти")]) : _vm._e()] : [(_vm.isAuthenticated) ? _c('v-icon', {
    attrs: {
      "color": "white"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_vm._v("fa-sign-out")]) : _vm._e()]], 2), _vm._v(" "), _c('v-content', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('transition', {
    attrs: {
      "name": "slide-fade"
    }
  }, [_c('router-view', {
    on: {
      "refresh": _vm.refresh
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 348:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ 44:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_router__ = __webpack_require__(339);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_2_vue_router__["a" /* default */]({
  routes: [
  //Main

  {
    path: '/login',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(8).then((function (require) {
          resolve(__webpack_require__(355));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  },
  //Admin Tools
  // {
  //   path: '/admin_tools/change_roles',
  //   component: () => import('@/components/AdminTools/ChangeRoles')
  // },
  // {
  //   path: '/admin/register_user',
  //   component: () => import('@/components/AdminTools/RegisterUser')
  // },
  {
    path: '/orders/list',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(2).then((function (require) {
          resolve(__webpack_require__(358));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/orders/create',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(0).then((function (require) {
          resolve(__webpack_require__(357));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/clients/list',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(1).then((function (require) {
          resolve(__webpack_require__(351));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/test',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(7).then((function (require) {
          resolve(__webpack_require__(360));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  },
  // {
  //   path: '/admin_tools/change_password',
  //   component: () => import('@/components/AdminTools/ChangePassword')
  // },
  //Notifications
  {
    path: '/products/list',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(3).then((function (require) {
          resolve(__webpack_require__(353));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/users/list',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(4).then((function (require) {
          resolve(__webpack_require__(354));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/reports/CouriersDailyReports',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(5).then((function (require) {
          resolve(__webpack_require__(359));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/notification/notifications',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(9).then((function (require) {
          resolve(__webpack_require__(356));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }, {
    path: '/Dashboard/',
    component: function component() {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        __webpack_require__.e/* require.ensure */(6).then((function (require) {
          resolve(__webpack_require__(352));
        }).bind(null, __webpack_require__)).catch(__webpack_require__.oe);
      });
    }
  }]
}));

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(77);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr__ = __webpack_require__(139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_toastr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_toastr__);




// You can use your own logic to set your local or production domain
var localDomain = "https://localhost:5001/api/v1/";
var testDomain = "http://botracer.ru:5000/api/v1/";
var prodDomain = "http://45.141.103.232:5000/api/v1/";
// The base URL is empty this time due we are using the jsonplaceholder API
var baseURL = "" + prodDomain;

var instance = __WEBPACK_IMPORTED_MODULE_2_axios___default.a.create({
  baseURL: baseURL
});

instance.interceptors.request.use(function (request) {
  request.headers.Authorization = "Bearer " + window.localStorage.getItem("token");
  return request;
}, function (error) {
  return error;
});
instance.interceptors.response.use(function (response) {
  return response;
}, errorHandler);

function errorHandler(error) {
  if (!error.response) return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
  switch (error.response.status) {
    case 401:
      window.location.href = window.location.origin + "/#/login";
      break;
    case 400:
      console.log(error.response.data);
      var key = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(error.response.data.errors)[0];
      var messages = key + ": " + error.response.data.errors[key];
      __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error(messages, "Ошибка!");
      break;
    case 500:
      __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error("Ошибка сервера");
      break;
    default:
      __WEBPACK_IMPORTED_MODULE_3_toastr___default.a.error(error.response.data.message, "Ошибка!");
  }

  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.reject(error);
}

/* harmony default export */ __webpack_exports__["a"] = (instance);

/***/ }),

/***/ 90:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return menu; });
var menu = [
// {
//   Title: "Администрирование",
//   Access: ["ADMIN"],
//   Icon: "fa-cog",
//   Pages: [
//     {
//       Title: "Регистрация пользователей",
//       Path: "/admin/register_user",
//       Icon: "fa-",
//       Access: ["ADMIN"],
//     },
//   ],
// },
{
  Title: "Дашбоард",
  Access: ["ADMIN"],
  Path: "/Dashboard/",
  Icon: "fa-list",
  Pages: []
}, {
  Title: "Списки",
  Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"],
  Icon: "fa-list",
  Pages: [{
    Title: "Клиенты",
    Path: "/clients/list",
    Icon: "fa-user",
    Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"]
  }, {
    Title: "Пользователи",
    Path: "/users/list",
    Icon: "fa-user",
    Access: ["ADMIN"]
  }, {
    Title: "Продукты",
    Path: "/products/list",
    Icon: "fa-product-hunt",
    Access: ["ADMIN"]
  }]
}, {
  Title: "Заказы",
  Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"],
  Icon: "fa-cog",
  Pages: [{
    Title: "Создать заказ",
    Path: "/orders/create",
    Icon: "fa-plus",
    Access: ["OPERATOR"]
  }, {
    Title: "Список заказов",
    Path: "/orders/list",
    Icon: "fa-list",
    Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"]
  }]
}, {
  Title: "Отчеты",
  Access: ["ADMIN", "CASHIER", "DELIVERYMANAGER"],
  Icon: "fa-list",
  Pages: [{
    Title: "Отчеты по курьерам",
    Path: "/reports/CouriersDailyReports",
    Icon: "fa-user",
    Access: ["ADMIN", "CASHIER", "DELIVERYMANAGER"]
  }]
}, {
  Title: "Тест",
  Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"],
  Icon: "fa-list",
  Pages: [{
    Title: "2GIS",
    Path: "/test",
    Icon: "fa-user",
    Access: ["ADMIN", "OPERATOR", "DELIVERYMANAGER"]
  }]
}];

/***/ }),

/***/ 91:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_resource__ = __webpack_require__(338);




__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_3_vue_resource__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = ({

  user: {
    login: '',
    authenticated: false,
    tokenExpire: '',
    token: '',
    userGuid: '',
    roles: [],
    permissions: []
  },
  errorHandler: function errorHandler(err, context) {
    if (err.status == 401) {
      this.logout();
      __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].replace('/login');
    } else this.showToast(context, this.err);
    console.log(err);
  },
  newGuid: function newGuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0,
          v = c == 'x' ? r : r & 0x3 | 0x8;
      return v.toString(16);
    });
  },
  post: function post(context, method, body) {
    var _this = this;

    var toast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var contentType = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';

    var symbol = method.indexOf("&") > 0 ? "" : "?";
    return context.$http.post(method + symbol + 'token=' + this.user.token, body, {
      headers: {
        'Content-Type': contentType == '' ? 'application/json' : contentType
      }
    }).then(function (data) {
      _this.data = {
        status: data.status,
        data: JSON.parse(data.bodyText == '' ? '{}' : data.bodyText)
      };

      if (toast) _this.showToast(context, _this.data);
      return _this.data;
    }).catch(function (err) {
      _this.err = {
        status: err.status,
        data: JSON.parse(err.bodyText == '' ? '{}' : err.bodyText)
      };
      _this.errorHandler(_this.err, context);
      return _this.err;
    });
  },
  get: function get(context, method) {
    var _this2 = this;

    var body = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var toast = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

    return context.$http.get(method + (body == '' ? '?' : body + '&') + 'token=' + this.user.token, {
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(function (data) {
      _this2.data = {
        status: data.status,
        data: JSON.parse(data.bodyText == '' ? '{}' : data.bodyText)
      };

      if (toast) _this2.showToast(context, _this2.data);
      return _this2.data;
    }).catch(function (err) {
      _this2.err = {
        status: err.status,
        data: JSON.parse(err.bodyText == '' ? '{}' : err.bodyText)
      };
      _this2.errorHandler(_this2.err, context);
    });
  },
  login: function login(context, body) {
    var _this3 = this;

    var request = this.post(context, '/api/User/Login', body);
    request.then(function (response) {
      var data = response.data;
      localStorage.setItem('token', data.Token);
      localStorage.setItem('tokenExpire', data.ExpiredAt);
      localStorage.setItem('userGuid', data.UserGuid);
      localStorage.setItem('login', data.Login);
      localStorage.setItem('roles', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Roles));
      localStorage.setItem('permissions', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(data.Permissions));

      _this3.user.authenticated = true;
      _this3.user.token = data.Token;
      _this3.user.tokenExpire = data.ExpiredAt;
      _this3.user.userGuid = data.UserGuid;
      _this3.user.login = data.Login;
      _this3.user.roles = data.Roles;
      _this3.user.permissions = data.Permissions;

      // router.push(data.Permissions[0].Pages[0].Path)
    }, function (err) {
      return errorHandler(err);
    });
    return request;
  },


  //Admin Tools
  getSMSCode: function getSMSCode(context, body) {
    return this.post(context, '/api/AdminTools/GetSMSCode', body);
  },
  getUserRoles: function getUserRoles(context, body) {
    return this.post(context, '/api/AdminTools/GetUserRoles', body);
  },
  getRoles: function getRoles(context) {
    return this.get(context, '/api/AdminTools/Roles');
  },
  changeRole: function changeRole(context, body) {
    return this.post(context, '/api/AdminTools/ChangeRole', body, true);
  },
  changePassword: function changePassword(context, body) {
    return this.post(context, '/api/AdminTools/ChangePassword', body, true);
  },


  //USERS
  getAgents: function getAgents(context, body) {
    return this.post(context, '/api/Main/GetAgentsList', body);
  },
  getCashiers: function getCashiers(context, body) {
    return this.post(context, '/api/Main/GetCashiersList', body);
  },
  cashOutToCashier: function cashOutToCashier(context, body) {
    return this.post(context, '/api/Main/CashOutToCashier', body, true);
  },
  cashOutToAgent: function cashOutToAgent(context, body) {
    return this.post(context, '/api/Main/CashOutToAgent', body, true);
  },
  changeUserData: function changeUserData(context, body) {
    return this.post(context, '/api/Main/ChangeUserData', body, true);
  },
  registerUser: function registerUser(context, body) {
    return this.post(context, '/api/User/RegisterUser', body, true);
  },
  findUser: function findUser(context, body) {
    return this.get(context, '/api/User/FindUser?query=', body);
  },
  balance: function balance(context) {
    return this.get(context, '/api/User/Balance');
  },
  exportToExcel: function exportToExcel(context, body) {
    return this.post(context, '/api/Report/HistoryToExcel', body, true);
  },


  //Notifications
  sentNotyToAll: function sentNotyToAll(context, body) {
    return this.post(context, '/api/Notification/SentToAll', body);
  },
  sentNotyToUser: function sentNotyToUser(context, body) {
    return this.post(context, '/api/Notification/SentToUser', body);
  },


  //Reports

  // getTechnicalReport(context, body) {
  //   return this.post(context, '/api/Report/Technical', body);
  // },
  getTransactionLog: function getTransactionLog(context, body) {
    return this.post(context, '/api/Report/Log', body);
  },
  getLastHistory: function getLastHistory(context, body) {
    return this.post(context, '/api/Report/LastHistory', body);
  },
  getSummaryByRegion: function getSummaryByRegion(context, body) {
    return this.post(context, '/api/Report/SummaryByRegion', body);
  },
  getSummaryByOperator: function getSummaryByOperator(context, body) {
    return this.post(context, '/api/Report/SummaryByOperator', body);
  },
  getSummaryByTariff: function getSummaryByTariff(context, body) {
    return this.post(context, '/api/Report/SummaryByTariff', body);
  },
  getFinancialReport: function getFinancialReport(context, body) {
    return this.post(context, '/api/Report/Financial', body);
  },
  getTuaReport: function getTuaReport(context, body) {
    return this.post(context, '/api/Report/Tua', body);
  },
  getNonBillingReport: function getNonBillingReport(context, body) {
    return this.post(context, '/api/Report/NonBilling', body);
  },
  getGeneralReport: function getGeneralReport(context, body) {
    return this.post(context, '/api/Report/General', body);
  },
  getRemittanceReport: function getRemittanceReport(context, body) {
    return this.post(context, '/api/Report/Remittance', body);
  },
  changePaymentState: function changePaymentState(context, body) {
    return this.post(context, '/api/TransactionsQueue/Change', body, true);
  },
  transactionDetails: function transactionDetails(context, body) {
    return this.post(context, '/api/Report/Details', body);
  },
  getLocations: function getLocations(context, body) {
    return this.post(context, '/api/User/Locations', body);
  },
  getAllLocations: function getAllLocations(context) {
    return this.get(context, '/api/User/GetAllLocations');
  },
  getUserLimit: function getUserLimit(context, body) {
    return this.post(context, '/api/User/UserLimit', body);
  },
  saveUserLimit: function saveUserLimit(context, body) {
    return this.post(context, '/api/User/SaveLimit', body, true);
  },
  dashboard: function dashboard(context) {
    return this.get(context, '/api/Main/Dashboard');
  },
  getRemittanceInfo: function getRemittanceInfo(context, body) {
    return this.post(context, '/api/Remittance/RemittanceInfo', body);
  },
  acceptRemittance: function acceptRemittance(context, body) {
    return this.post(context, '/api/Remittance/Remittance', body, true);
  },


  //Charts
  getAgentsCollected: function getAgentsCollected(context, body) {
    return this.post(context, 'api/Chart/AgentsCollected', body);
  },

  // getSalesAndProfitByProviders(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndProfitByProviders', body);
  // },
  // getSalesAndProfitDynamicsByProviders(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndProfitDynamicsByProviders', body);
  // },
  // getSalesAndAgentsDepositesDynamic(context, body) {
  //   return this.post(context, 'api/Chart/SalesAndAgentsDepositesDynamic', body);
  // },
  // getAgentsDepositsAndProfitBalance(context, body) {
  //   return this.post(context, 'api/Chart/AgentsDepositsAndProfitBalance', body);
  // },
  // getSalesByAirtimeCredit(context, body) {
  //   return this.post(context, 'api/Chart/SalesByAirtimeCredit', body);
  // },
  // getNumberOfTUAAccounts(context, body) {
  //   return this.post(context, 'api/Chart/NumberOfTUAAccounts', body);
  // },
  // getMonthlyTotalSales(context, body) {
  //   return this.post(context, 'api/Chart/MonthlyTotalSales', body);
  // },
  // getAgentsSales(context, body) {
  //   return this.post(context, 'api/Chart/AgentsSales', body);
  // },


  showToast: function showToast(context, data) {
    if (data.status == 200) context.$toast.success({
      title: 'Successfully!',
      message: data.data.Message

    });else if (data.status >= 400) context.$toast.error({
      title: 'Error!',
      message: data.data.Message

    });
  },

  //////////////////
  logout: function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('userGuid');
    localStorage.removeItem('login');
    localStorage.removeItem('roles');
    localStorage.removeItem('permissions');
    this.user.authenticated = false;
  },
  checkAuth: function checkAuth() {

    var tokenExpiredAt = localStorage.getItem('tokenExpire');
    var dateTimeNow = Date.now() / 1000;
    this.user.authenticated = localStorage.getItem('tokenExpire') != "" && localStorage.getItem('tokenExpire') != null && tokenExpiredAt > dateTimeNow;
    if (this.user.authenticated) {
      this.user.token = localStorage.getItem('token');
      this.user.tokenExpire = localStorage.getItem('tokenExpire');
      this.user.userGuid = localStorage.getItem('userGuid');
      this.user.login = localStorage.getItem('login');
      this.user.roles = JSON.parse(localStorage.getItem('roles'));
      this.user.permissions = JSON.parse(localStorage.getItem('permissions'));
    }
  }
});

/***/ })

},[180]);


// WEBPACK FOOTER //
// static/js/app.54bb638efcb9e6695ebe.js